import script from "./BaseHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseHeader.vue?vue&type=script&lang=ts&setup=true"

import "./BaseHeader.vue?vue&type=style&index=0&id=3a3119cc&lang=scss&scoped=true"

import exportComponent from "C:\\Projekte\\wordpress\\eh3\\wp-content\\themes\\io.shop-standalone-energiehoch3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a3119cc"]])

export default __exports__